export default {
  home: {
    meta: {
      title: "AllChinaBuy Spreadsheet 2026: Fund, guider & ressourcer",
      description:
        "Udforsk det nyeste AllChinaBuy spreadsheet, produktfund, købsguider, forsendelsestips, QC-oplysninger og relaterede ressourcer i ét organiseret hub.",
      keywords:
        "AllChinaBuy spreadsheet, AllChinaBuy fund, AllChinaBuy guide, AllChinaBuy anmeldelse",
    },
    hero: {
      badge: "Opdateret for 2026 · Flersproget · Lavet til købere",
      title: "AllChinaBuy Spreadsheet",
      titleAccent: "— Opdag bedre fund & guider",
      subtitle:
        "Leder du efter det nyeste AllChinaBuy spreadsheet? Udforsk organiserede produktfund, købsguider, QC-oplysninger, forsendelsestips og relaterede ressourcer — alt i ét enkelt, søgbart hub.",
      ctaPrimary: "Udforsk AllChinaBuy Spreadsheet",
      ctaSecondary: "Køb nu",
      trust: "Uafhængig ressource · Opdateres løbende · Flersproget",
      mockup: {
        label: "Spreadsheet-forhåndsvisning",
        header: "Kategori",
        headerProduct: "Produkt",
        headerResource: "Ressource",
        headerQc: "QC",
        headerUpdated: "Opdat.",
        row1: "Sko",
        row1Product: "Sneakers",
        row1Qc: "Ja",
        row2: "Hættetrøjer",
        row2Product: "Sweatshirt",
        row2Qc: "Ja",
        row3: "Tasker",
        row3Product: "Tote",
        row3Qc: "Ja",
        row4: "Tilbehør",
        row4Product: "Ur",
        row4Qc: "Anmeld.",
      },
    },
    categories: {
      title: "Gennemse efter kategori",
      subtitle:
        "Vælg en kategori fra rullemenuen eller kortene nedenfor for at hoppe direkte til det matchende udvalg på hovedsiden.",
      dropdownLabel: "Vælg en kategori",
      dropdownPlaceholder: "Vælg en kategori for at fortsætte",
      dropdownCta: "Gå til kategori",
      gridTitle: "Populære produktkategorier",
      gridSubtitle: "Tryk på en kategori for at udforske kuraterede fund på hovedsiden.",
      allExternal: "Alle kategorier åbner i en ny fane.",
    },
    about: {
      title: "Alt, hvad du behøver for at udforske AllChinaBuy",
      subtitle:
        "Find de oplysninger, du har brug for, før du browser, sammenligner eller køber — organiseret, så du kommer hurtigere videre.",
      p1: "Et AllChinaBuy spreadsheet er en enkel og organiseret måde at holde styr på produktfund, sælgernoter, QC-resultater og forsendelsesdetaljer på ét sted. I stedet for at scrolle uendeligt gennem søgeresultater bruger købere et spreadsheet til at samle links, sammenligne muligheder og planlægge deres næste ordre med et klart overblik.",
      p2: "Dette hub samler de mest nyttige ressourcer omkring AllChinaBuy spreadsheet — fra kategorigenveje og købsguider til forsendelses- og QC-oplysninger — så du bruger mindre tid på at søge og mere tid på at finde de ting, du faktisk vil have.",
      points: {
        organized: {
          title: "Organiserede fund",
          desc: "Saml produkter og links i én klar, søgbar visning.",
        },
        compare: {
          title: "Nem sammenligning",
          desc: "Sammenlign varer side om side, før du køber.",
        },
        updated: {
          title: "Altid aktuel",
          desc: "Følg guider og ressourcer, der opdateres løbende.",
        },
      },
    },
    guides: {
      title: "Udforsk ressourcecenteret",
      subtitle: "Guider, der hjælper dig med at shoppe smartere med AllChinaBuy.",
      cards: {
        spreadsheet: {
          title: "AllChinaBuy Spreadsheet",
          desc: "Udforsk organiserede spreadsheet-ressourcer og produktkategorier.",
        },
        finds: {
          title: "Populære fund",
          desc: "Opdag populære produktkategorier og nyttige ressourcer.",
        },
        shipping: {
          title: "Forsendelsesguide",
          desc: "Forstå forsendelsesmetoder, omkostninger og vigtige overvejelser.",
        },
        qc: {
          title: "QC-guide",
          desc: "Lær at vurdere produktkvalitet, før du køber.",
        },
        review: {
          title: "AllChinaBuy-anmeldelse",
          desc: "Udforsk funktioner, fordele, begrænsninger og vigtige overvejelser.",
        },
        safety: {
          title: "Sikkerhedscenter",
          desc: "Sælgertjek, betalingssikkerhed, produktrisici og forsendelse.",
        },
      },
      cta: "Udforsk ressourcecenteret",
    },
    article: {
      title: "Seneste guider",
      subtitle: "Friske, originale artikler skrevet til at hjælpe dig med at shoppe smartere.",
      cardTitle: "AllChinaBuy Spreadsheet: Den komplette guide",
      cardDesc:
        "Lær, hvad et AllChinaBuy spreadsheet er, hvordan du bruger det, hvilke kategorier du skal udforske, og de tips, der hjælper dig med at finde bedre produkter hurtigere.",
      tag: "Komplet guide",
      readMore: "Læs den fulde guide",
      updated: "Sidst opdateret",
    },
    faq: {
      title: "Ofte stillede spørgsmål",
      subtitle: "Hurtige svar på de mest almindelige spørgsmål om AllChinaBuy spreadsheet.",
      q1: "Hvad er et AllChinaBuy spreadsheet?",
      a1: "Det er en organiseret ressource, der viser produktfund, kategorier, sælgernoter og QC-detaljer, så købere kan gennemse og sammenligne på ét sted.",
      q2: "Hvordan bruger jeg et AllChinaBuy spreadsheet?",
      a2: "Vælg en kategori, gennemse de linkede fund, og sammenlign, før du åbner hovedsiden for at gennemføre dit køb.",
      q3: "Er AllChinaBuy legitimt?",
      a3: "AllChinaBuy er en købsplatform, men du bør altid selv vurdere produkter, sælgere, betalingsmetoder og forsendelsesmuligheder, før du beslutter dig.",
      q4: "Er AllChinaBuy sikkert?",
      a4: "Sikkerhed afhænger af, hvordan du bruger tjenesten. Gennemgå sælgeroplysninger, QC-billeder og betalingsmuligheder nøje, før du bestiller.",
      q5: "Hvor meget koster AllChinaBuy-forsendelse?",
      a5: "Forsendelsesomkostninger varierer efter destination, vægt og metode, så tjek de aktuelle priser direkte på hovedsiden for et præcist estimat.",
      q6: "Har AllChinaBuy kuponer?",
      a6: "Tilbud og rabatter ændrer sig over tid. Besøg hovedsiden for at se, hvilke tilbud der er tilgængelige lige nu.",
      q7: "Hvad er AllChinaBuy-lageret?",
      a7: "Lageret er der, hvor købte varer modtages, opbevares, fotograferes til QC og klargøres til international forsendelse.",
      q8: "Hvordan fungerer AllChinaBuy QC?",
      a8: "QC lader dig anmode om inspektionsbilleder af dine varer før forsendelse, så du kan bekræfte kvaliteten og opdage problemer tidligt.",
    },
    finalCta: {
      title: "Klar til at udforske AllChinaBuy-ressourcer?",
      subtitle:
        "Start med AllChinaBuy spreadsheet og opdag de guider, fund og ressourcer, der betyder mest.",
      primary: "Udforsk AllChinaBuy Spreadsheet",
      secondary: "Besøg hovedsiden",
    },
  },
};